(function() {
	'use strict';

	angular
		.module('app')
		.factory('CarritoService', CarritoService);

	CarritoService.$inject = ['$http'];

	function CarritoService($http) {

		var service = {
			carrito: [],
			num_cart: 0,
			sumaTotal: 0,
			sumaCarrito: 0,
			newprodcart: newprodcart,
			getCarrito: getCarrito,
			deleteProdcart: deleteProdcart,
			modifycart: modifycart,

		};

		return service;

		function getCarrito(callback) {
			var config = {
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
				}
			}

			var data = $.param({
				//prod_id:prod_id,
				// extraSum:JSON.stringify(this.extraSum),
				// lang_id:lang_id
			});
			$http.post('/ajax/getcarrito', data, config)
				.then(getContentSuccess, getContentFailed);
			function getContentSuccess(data) {
				callback(data.data);
			}
			function getContentFailed(data) {
				return false;
			}
		}

		function newprodcart(prod_id, content_type, callback) {
			var config = {
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
				}
			}

			var data = $.param({
				prod_id: prod_id,
				content_type: content_type,
				lang_id: lang_id
			});
			$http.post('/ajax/newprodcart', data, config)
				.then(getContentSuccess, getContentFailed);
			function getContentSuccess(data) {
				callback(data.data);
			}
			function getContentFailed(data) {
				return false;
			}
		}


		function deleteProdcart(prod_id, content_type, callback) {
			var config = {
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
				}
			}

			var data = $.param({
				prod_id: prod_id,
				content_type: content_type,
				lang_id: lang_id,
			});
			$http.post('/ajax/deleteprodcart', data, config)
				.then(getContentSuccess, getContentFailed);
			function getContentSuccess(data) {
				callback(data.data);
			}
			function getContentFailed(data) {
				return false;
			}
		}

		function modifycart(prod_id, content_type, quantity, callback) {
			var config = {
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
				}
			}

			var data = $.param({
				prod_id: prod_id,
				content_type: content_type,
				quantity: quantity,
				lang_id: lang_id

			});
			$http.post('/ajax/modifyquantity', data, config)
				.then(getContentSuccess, getContentFailed);
			function getContentSuccess(data) {
				callback(data.data);
			}
			function getContentFailed(data) {
				return false;
			}
		}







	}
})();
